import { graphql } from 'babel-plugin-relay/macro';
import {
  TranslationExerciseContentInput,
  CreateTranslationExerciseMutation,
} from './__generated__/CreateTranslationExerciseMutation.graphql';
import { commitMutationPromise } from '../lib/graphqlUtils';
import {
  addExerciseToStore,
  optimisticCreateExerciseUpdater,
} from './helpers/exerciseMutationHelpers';
const mutation = graphql`
  mutation CreateTranslationExerciseMutation(
    $input: CreateTranslationExerciseInput!
  ) {
    createTranslationExercise(input: $input) {
      exercise {
        id
        content {
          prompt
          correctAnswers
          scrambledParts
        }
        worksheet {
          id
        }
      }
    }
  }
`;

const commit = (
  environment: any,
  worksheetId: string,
  content: TranslationExerciseContentInput,
  position: number,
) =>
  commitMutationPromise<CreateTranslationExerciseMutation>(environment, {
    mutation,
    variables: {
      input: {
        worksheetId,
        content,
        position,
      },
    },
    optimisticUpdater: optimisticCreateExerciseUpdater(
      'TranslationExercise',
      worksheetId,
      content,
      position,
    ),
    updater: store => {
      const payload = store.getRootField('createTranslationExercise');
      if (payload) {
        const newExercise = payload.getLinkedRecord('exercise');
        addExerciseToStore(store, newExercise, worksheetId, position);
      }
    },
  });

export default {
  commit,
};
